import { MutationKey } from '@tanstack/query-core';

import { CommonSuccess, GenericFailure } from '@playq/services-shared';
import { SpaceID } from '@playq/octopus-common';
import { AppPromotions } from '@playq/octopus2-apps-utility';

import { useEitherMutation, UseMutationOptionsExtended } from '/api/service-hooks';
import { experimentsQueryKeys, flowQueryKeys, gameEventsQueryKeys, services2 } from '/api';
import { snackbarService } from '/common/snackbarService';

import { spacePromotionsUpdateKey } from './constants';

export type UseAppSpacePromotionsUpdateParams = {
  spaceID: SpaceID;
  promotions: AppPromotions;
};

export const useAppSpacePromotionsUpdate = (
  options?: UseMutationOptionsExtended<CommonSuccess, GenericFailure | Error, UseAppSpacePromotionsUpdateParams>
) => {
  return useEitherMutation(
    ({ spaceID, promotions }) => services2.spacesPromotionsService.updatePromotions(spaceID, promotions),
    {
      onSuccess: () => {
        snackbarService.success('All the entities were successfully promoted to selected space');
      },

      removeQueriesKeysArray: [experimentsQueryKeys, flowQueryKeys, gameEventsQueryKeys],
      mutationKey: spacePromotionsUpdateKey as MutationKey,
      ...options,
    }
  );
};
